import { render, staticRenderFns } from "./CustomCategoriesFilter.vue?vue&type=template&id=5d2c2a1f&lang=pug&"
import script from "./CustomCategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./CustomCategoriesFilter.vue?vue&type=script&lang=js&"
import style0 from "./CustomCategoriesFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports